import React from 'react'
import { Project, PermissionReducer, ModuleReducer } from '@leverege/api-redux'
import { List, Content, Flex, Button, Text, Toast } from '@leverege/ui-elements'
import ModelUtil from '@leverege/model-util'
import { ValuesCache } from '@leverege/value-cache'
import { connect } from 'react-redux'
import ModuleEditor from './ModuleEditor'
import PermissionEditor from './PermissionEditor'
import PermissionModel from './PermissionModel'
import EditModel from './EditModel'
import FilterInput from './FilterInput'

import { filterModules, filterAndGroupPermissions } from './Util'

import S from './PermissionScreen.css'
import AddDialog from './AddDialog'

const { changeObject } = ModelUtil

class PermissionScreen extends React.Component {

  constructor( props ) {
    super( props )
    this.cache = new ValuesCache()
    this.state = { 
      showCreate : false,
      actionState : null,
      selection : null,
      filter : { inCustom : true, inProject : false, inImagine : false, search : null }
    }
    this.selector = new List.SingleSelector( this, 'selection', { idFunc } )
  }

  static getDerivedStateFromProps( props, state ) {
    // Set the correct selection
    const cs = state.selection
    const ns = props.match.params.permissionId
    if ( cs != ns ) {
      return { selection : ns }
    }
    return null
  }

  onFilter = ( event ) => {
    this.setState( { [event.data] : event.value } )
  }

  onSelect = ( item ) => {
    const { match, history, dispatch } = this.props
    const projectId = match.params.projectId
    const id = item.permission != null ? item.permission.id : `${item.projectId}-${item.name}`
    history.push( `/project/${projectId}/authz/permission/${id}` )
  }

  onShowCreate = ( event ) => {
    this.setState( { showCreate : true, targetModule : event.data } )
  }

  onCloseCreate = ( event ) => {
    this.setState( { showCreate : false, targetModule : null } )
  }

  onCreatePermission = ( item ) => {
    const { targetModule } = this.state
    const { match, dispatch } = this.props 
    const nPerm = { ...item, module : targetModule.name }
    delete nPerm.scope

    dispatch( Project( match.params.projectId ).permissions( ).create( nPerm ) )
      .then( ( e ) => { 
        this.setState( { actionState : null, showCreate : false, targetModule : null } )
      }, ( err ) => {
        this.setState( { actionState : 'saveError' } ) 
        Toast.error( err.message, {} )
      } )

  }

  onSave = ( event ) => {
    let updating = false
    const { dispatch } = this.props
    const { value, oldValue } = event
    const isModule = value.module === undefined
    const func = isModule ? 'module' : 'permission'
    const id = isModule ? value.name : value.id
    const keys = isModule ? [ 'displayName', 'category', 'description' ] : [ 'name', 'displayName', 'category', 'description' ]
    const opts = { undefinedIsNull : true, keys }
    const change = changeObject( value, oldValue, opts )

    if ( Object.keys( change ).length > 0 ) {
      updating = true
      dispatch( Project( value.projectId )[func]( id ).update( change ) )
        .then( ( e ) => { 
          this.setState( { actionState : null } ) 
        }, ( err ) => {
          this.setState( { actionState : 'saveError' } ) 
          Toast.error( err.message, {} )
        } )
    }
    if ( updating ) {
      this.setState( { actionState : 'saving' } ) 
    } else {
      Toast.success( 'No changes to save', {} )
    }

  }

  onDelete = ( item ) => {
    const { dispatch, history } = this.props

    const isModule = item.module === undefined
    const func = isModule ? 'module' : 'permission'
    const id = isModule ? item.name : item.id

    this.setState( { actionState : 'deleting' } ) 
    dispatch( Project( item.projectId )[func]( id ).delete( ) )
      .then( ( ) => {
        this.setState( { selection : null, actionState : 'deleted' } ) 
        const path = history.location.pathname
        history.replace( `/project/${item.projectId}/authz/permission` )
      },
      ( err ) => {
        this.setState( { actionState : 'deleteError' } ) 

        const msg = (
          <div>
            <Text variant="toastTitle">Role Deletion Failed</Text>
            <Text variant="toastMsg">{err.message}</Text>
          </div>
        )
        Toast.error( msg, { } )
      } )
  }

  getSelectedItem( ) {
    const { selection } = this.state
    const { permissions = [], imaginePermissions = [], modules } = this.props
    if ( selection == null ) {
      return null
    }
    const split = typeof selection === 'string' ? selection.split( '-' ) : [ selection ]
    if ( split.length === 1 ) {
      // permissions
      return permissions.find( ( r ) => { return r.id == selection } ) ||
             imaginePermissions.find( ( r ) => { return r.id == selection } ) || null
       
    } 
    // modules
    const arr = ModuleReducer.getModules( modules, split[0] )
    return arr.find( ( m ) => { return m.name == split[1] } ) || null
    
  }

  render() {
    const { permissions = [], imaginePermissions = [], modules, match, history } = this.props
    const { filter, actionState, showCreate } = this.state
    let fPerms = this.cache.calc( 'perms', filterAndGroupPermissions, modules, permissions, imaginePermissions, filter, true )
    fPerms = this.cache.calc( 'all', filterModules, fPerms, modules, match.params.projectId, filter )
    
    const selectedItem = this.getSelectedItem()
    const isEditable = selectedItem == null ? false : selectedItem.projectId != 'imagine'
    const isCustom = selectedItem == null ? false : selectedItem.scope === 'custom'

    const type = selectedItem == null ? null : ( selectedItem.module ? 'Permission' : 'Module' )
    const Editor = type == null ? null : ( type === 'Permission' ? PermissionEditor : ModuleEditor )

    return (
      <Content horizontal>
        <Content.Area>
          <Content>
            <Content.Header className={S.padding}>
              <FilterInput value={filter} eventData="filter" onChange={this.onFilter} />
            </Content.Header>
            <Content.Area>
              <List selector={this.selector} onSelect={this.onSelect}>
                {
                  fPerms.map( ( grp ) => {
                    let custom = false
                    let type = 'PROJECT'
                    if ( grp.module.projectId === 'imagine' ) {
                      type = 'IMAGINE'
                    } else if ( grp.module.scope === 'custom' ) {
                      type = 'CUSTOM'
                      custom = true
                    }
                    return ( [
                      // <React.Fragment key={`${grp.module.name}-${grp.module.projectId}`}>
                      <List.Item item={grp.module}>     
                        <Flex variant="rowS" align="baseline" >
                          {grp.module.displayName || grp.module.name}
                          <Text variant="info">{type}</Text>
                          { custom && (
                            <Button 
                              title="Create Permission" 
                              variant="secondaryTinyIconic" 
                              eventData={grp.module} 
                              onClick={this.onShowCreate}><i className="fa fa-plus"/>
                            </Button>
                          )}
                        </Flex>
                      </List.Item>,
                      <List.Dynamic 
                        items={grp.permissions} 
                        component={PermissionItem} />
                      // </React.Fragment>
                    ] )
                  } ) 
                }
              </List>
            </Content.Area>
            <Content.Footer className={S.filters} />
          </Content>
        </Content.Area>
          
        <Content.Footer className={S.editor}>
          <EditModel 
            editor={Editor}
            history={history}
            title={getTitle}
            actionState={actionState}
            saveOnChange={false}
            editorProps={{ isEditable }}
            deleteTitle={`Delete ${type}?`}
            deleteMessage={getDeleteMessage( type )}
            value={selectedItem} 
            onDelete={isEditable && isCustom ? this.onDelete : null} 
            onSave={this.onSave} />
          <AddDialog 
            title="Create Permissions"
            editor={PermissionEditor}
            creator={PermissionModel}
            onClose={this.onCloseCreate} 
            onCreate={this.onCreatePermission} 
            show={showCreate}/>
        </Content.Footer>
    
      </Content>
    )
  }
}

export default connect(
  ( state ) => {
    return {
      permissions : PermissionReducer.getPermissions( state.permissions, state.project.id ),
      imaginePermissions : PermissionReducer.getPermissions( state.permissions, 'imagine' ),
      status : PermissionReducer.getStatus( state.permissions, state.project.id ),
      error : PermissionReducer.getError( state.permissions, state.project.id ),
      modules : state.modules,
    }
  }
)( PermissionScreen )

function idFunc( item ) {
  if ( item.permission != null ) {
    return item.permission.id
  } 
  return `${item.projectId}-${item.name}`
}

function getTitle( model, original, variant ) {
  return (
    [
      <Text key="title" variant={variant}>{original.displayName || original.name}</Text>,
      <Text key="info" variant="info">{model.module == null ? 'MODULE' : 'PERMISSION' }</Text>
    ]
  )
}

function getDeleteMessage( type ) {
  if ( type === 'Module' ) {
    return 'This will permanently remove this Module and ALL its Permissions, and it may effect current users access.'
  } if ( type === 'Permission' ) {
    return 'This will permanently remove this Permission and may effect current users access.'
  }
  return ''
}

function PermissionItem( props ) {
  const { item, ...rest } = props
  const { displayName, name } = item.permission
  return (
    <List.Item item={item} {...rest} >
      <Text className={S.permission} variant="listItemSubtitle">{displayName || name}</Text>
    </List.Item>
  )
}
